import { AnnouncementFormData } from '../types';

const initAnnouncement: AnnouncementFormData = {
  Title: '',
  Description: '',
  MoreLink: '',
  ExpireDate: null,
};

export default initAnnouncement;
